import { ViviendaModel, DepartamentoModel, PredioRuralModel } from './tiposDomicilio.model';
export class DomicilioModel {
	
  Provincia: string='';
  Canton: string = '';
  Parroquia: string = '';
  CodProvincia: string = '';
  CodCanton: string = '';
  CodParroquia: string = '';
  Direccion: string = '';
  CodTipoDomicilio!: number;
  ValoresTipoDomicilio!: TipoDomicilioCamposModel;
  Referencia: string = '';
  Coordenadas!: string; //seperados por coma
  CodigoArea: string = '';
  Telefono: string = '';
  TipoVivienda: string = '';
  ValorVivienda!: number;
  TiempoResidencia!: number;


  clear() {
    this.Provincia = '';
    this.Canton = '';
    this.Parroquia = '';
    this.CodProvincia = '';
    this.CodCanton = '';
    this.CodParroquia = '';
    this.Direccion = '';
    this.CodTipoDomicilio = 0;
    this.Referencia = '';
    this.Coordenadas = '';
    this.CodigoArea = '';
    this.Telefono = '';
    this.TipoVivienda = '';
    this.ValorVivienda = 0;
    this.TiempoResidencia = 0;

  }
}


export class TipoDomicilioCamposModel {
    TipoDeDomicilio!: number;
    CallePrincipal: string = '';
    CalleSecundaria: string = '';
    CasaVillaEdificio: string = '';
    Manzana: string = '';
    BarrioCiudadelaUrbanizacionSector: string = '';
    Etapa: string = '';
    NombreEdificio: string = '';
    NumeroDepartamento: string = '';
    NumeroPiso: string = '';
    DireccionCompleta: string = '';

  clear() {
    this.TipoDeDomicilio = 0;
    this.CallePrincipal = '';
    this.CalleSecundaria = '';
    this.CasaVillaEdificio = '';
    this.Manzana = '';
    this.BarrioCiudadelaUrbanizacionSector = '';
    this.Etapa = '';
    this.NombreEdificio = '';
    this.NumeroDepartamento = '';
    this.NumeroPiso = '';
    this.DireccionCompleta = '';
  }
}

